import Vue from "vue";

const CPFFilter = {
  install(Vue) {
    Vue.filter("cpfFilter", (documentId) => {
      documentId =
        typeof documentId != "string" ? documentId.toString() : documentId;

      documentId = documentId.padStart(11, "0");
      documentId = documentId.replace(
        /^(\d{3})(\d{3})(\d{3})(\d{2})/,
        "$1.$2.$3-$4"
      );

      return documentId;
    });
  },
};

Vue.filter("testeFilter", (value) => {
  return value.toUpperCase();
});

Vue.use(CPFFilter);
